// eslint-disable-next-line simple-import-sort/imports
import useCache from '@/hooks/useCache';
import config from '@/config';
import searchConfig from '@/config/search.config';

import ImageCategory from './components/ImageCategory';
import SearchUsers from './search-users';

import './index.css';
import NonImageCategory from './components/NonImageCategory';

export default function PreSearch() {
  const { fetchData } = useCache(`search-types`, `${config.apis.api.url}/searchtypes`,
    {
      type: "@cache/dynamic",
      injectToken: true,
    }
  );

  // const themes = searchConfig.search.main_search.search_categories.themes; // Corrected to use 'searchConfig'
  // const emotions = searchConfig.search.main_search.search_categories.emotions; // Corrected to use 'searchConfig'
  // const colors = searchConfig.search.main_search.search_categories.colors; // Corrected to use 'searchConfig'
  const size = searchConfig.search.main_search.search_categories.size; // Corrected to use 'searchConfig'
  const price = searchConfig.search.main_search.search_categories.price; // Corrected to use 'searchConfig'

  return (
    <>
      <div className="pre-search__container">
        <SearchUsers />

        {
          fetchData && fetchData.data.slice(0, 5).map(types => 
            ["size", "price"].indexOf(types.type_id) === -1 ?
              <ImageCategory
                key={types.type_id}
                type={types.type_id}
                categoryName={types.title}
                data={types.search_orders}
              />
              : 
              <NonImageCategory
                categoryName={types.title}
                key={types.type_id}
                data={(types.type_id === "size" ? size : price).map((item) => ({
                  ...item,
                  title: item.title,
                  metaDescription: item.metaDescription,
                }))}
              />
          )
        }
      </div>
    </>
  );
}